import { useCallback } from 'react';
import _ from 'lodash';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import { CepConstants } from 'saga-cep-specific-components';
import metadata from './SgAccountDetails.metadata.json5';
import './SgAccountDetails.messages';

function SgAccountDetails(props) {
    const {
        contactDetails
    } = props;

    const readValue = useCallback((id, path) => {
        return _.get(contactDetails, path);
    }, [contactDetails]);

    const overrides = {
        changeEmail: {
            href: CepConstants.CHANGE_EMAIL_LINK
        },
        changePassword: {
            href: CepConstants.CHANGE_PASSWORD_LINK
        },
        changeCommPref: {
            href: CepConstants.CHANGE_COMM_PREF_LINK
        }
    };
    const resolvers = {
        resolveValue: readValue
    };

    return renderContentFromMetadata(metadata.componentContent, overrides, resolvers);
}

export default SgAccountDetails;
